import React, { Component } from 'react'
import { NavLink } from "react-router-dom"

import Tools from '../utils/Tools'
import Utils from '../utils/Utils'

class Directory extends Component {
    constructor(props) {
        super(props)
        this.tools = Tools.getTools().sort((a, b) => {
            if (a.title && b.title) return a.title.localeCompare(b.title)
            return 0
        })
    }

    componentDidMount() {
        Utils.injectTwitterCardTags("Tool Directory")
    }
    componentWillUnmount() {
        Utils.removeTwitterCardTags()
    }

    render() {
        return (
            <div id="directory" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-px bg-border m-2 rounded-lg overflow-hidden border border-border">
                {this.tools.map(tool => (
                    <NavLink
                        key={ tool.link }
                        to={ tool.link }
                        data-cy={ tool.title.toLowerCase() }
                        className="bg-card hover:bg-accent transition-colors px-4 py-3 text-sm font-medium text-foreground hover:text-accent-foreground no-underline"
                    >
                        { tool.title }
                    </NavLink>
                ))}
            </div>
        )
    }
}

export default Directory
